import Ajax from '@/lib/ajax'
export default {
    /**
     * 创建优惠券活动
     * @param data 
     */
    addCouponActivity(data: any) {
        return Ajax.post(`/api/MarketingManagement/couponActivity`, data)
    },
    /**
     * 更新优惠券活动
     * @param id 
     * @param data 
     */
    updateCouponActivity(id: string, data: any) {
        return Ajax.put(`/api/MarketingManagement/couponActivity/${id}`, data)
    },
    /**
     * 获取优惠券活动信息
     * @param id 
     */
    getCouponActivity(id: string) {
        return Ajax.get(`/api/MarketingManagement/couponActivity/${id}`)
    },
    /**
     * 获取优惠券活动列表
     */
    getCouponList(pageSize: number, currentPage: number, type?: string, keyWord?: string, Status?: number,ExcludeUnPublished?:boolean) {
        return Ajax.get(`/api/MarketingManagement/couponActivity`, {
            params: {
                type,
                maxResultCount: pageSize,
                skipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
                keyWord,
                Status,
                ExcludeUnPublished
              }
        })
    }
}